<script>
  export let src;
  export let desc;
  export let href;

  const openLink = () => {
    window.open(href);
  };
</script>

<div class="container" on:click={openLink}>
  <span class="icon-wrapper">
    <img class="icon-icon" {src} alt="{desc}아이콘" />
  </span>
  <span class="desc">{desc}</span>
</div>

<style>
  .container {
    background-color: #f2f2f2;
    border-radius: 15px;
    width: 50%;
    margin: 0 auto;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 300;
    font-size: 48px;
    cursor: pointer;
    box-shadow: 1px 1px 3px #777;
    transition: 0.3s;
  }
  .container:hover {
    box-shadow: 2px 3px 4px #444;
  }
  .container:active {
    box-shadow: 0px 0px 0px;
    transition: 0s;
    transform: translate(2px, 3px);
  }
  .icon-wrapper {
    width: 80px;
    height: 80px;
    overflow: hidden;
    margin: 0;
    margin-right: 20px;
  }
  .icon-icon {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .desc {
  }
  @media screen and (max-width: 768px) {
    .container {
      width: 90%;
      height: 130px;
      font-size: 36px;
    }
    .desc {
      font-size: 8vw;
    }
  }
</style>
